import { render, staticRenderFns } from "./MsgElementText_Text.vue?vue&type=template&id=7d911b58"
import script from "./MsgElementText_Text.vue?vue&type=script&lang=js"
export * from "./MsgElementText_Text.vue?vue&type=script&lang=js"
import style0 from "./MsgElementText_Text.vue?vue&type=style&index=0&id=7d911b58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports